import { __decorate } from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import "@/helpers/element-ui";
let CallToAction = class CallToAction extends Vue {
    mounted() {
        const areaWrapper = document.getElementById("chat-area-wrapper");
        if (areaWrapper) {
            areaWrapper.classList.add("more-padding-bottom");
        }
    }
    beforeDestroy() {
        const areaWrapper = document.getElementById("chat-area-wrapper");
        if (areaWrapper) {
            areaWrapper.classList.remove("more-padding-bottom");
        }
    }
    emitCloseDialogEvent() {
        if (this.$parent) {
            this.$parent.$emit("CLOSE_CHAT_DIALOG", true);
        }
    }
};
__decorate([
    Prop({ type: String, default: "text" })
], CallToAction.prototype, "type", void 0);
__decorate([
    Prop({ type: String, default: "Chiudi conversazione" })
], CallToAction.prototype, "label", void 0);
CallToAction = __decorate([
    Component
], CallToAction);
export default CallToAction;
